<template>
  <div id="sleep">
    sleep
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sleep.vue